import { Theme } from '../../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import React from 'react';
import { CareClaim } from '../../../../Consts/CareClaimDefaultColumns.const';
import { useDisclose } from '../../../../../Modal/Hooks/useDisclose';
import ManagerInsuranceCompaniesCareClaimDeleteModal from './ManagerInsuranceCompaniesCareClaimDeleteModal';

interface Props {
	item: CareClaim;
	reloadData: () => void;
}

const ManagerInsuranceCompaniesCareClaimDelete = ({
	item,
	reloadData,
}: Props) => {
	const { isOpen, onOpen, onClose } = useDisclose();

	return (
		<>
			<LinkButton
				title='base.shared.remove'
				theme={Theme.RED}
				onClick={onOpen}
				disabled={!item.canDelete}
			/>
			{isOpen && (
				<ManagerInsuranceCompaniesCareClaimDeleteModal
					isOpen
					onClose={onClose}
					careClaimId={item.id}
					reloadData={reloadData}
				/>
			)}
		</>
	);
};

export default ManagerInsuranceCompaniesCareClaimDelete;
